import * as React from 'react';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import { Link } from 'react-router-dom';
import BeHead from '../../Components/Head/BeHead';
// import logo from "../../../Assets/Images/Bloc-Logo.png";
// import image1 from '../../../Assets/Images/image1.png';

function createData(step, title) {
  return { step, title };
}

const rows = [
  createData(1, 'CADRAGE DU PROJET'),
  createData(2, 'TOITURE'),
  createData(3, 'MUR ET USAGE'),
  createData(4, 'CHARPENTE'),
  createData(5, 'DIMENSIONS ET PLANS'),
];

export default function SelectStep() {
  
  const handleRowClick = (row) => {
    console.log('Ligne cliquée :', row);
    // Exemple : redirection, modal, etc.
    // navigate(`/details/${row.name}`); ou openModal(row)
  };

  return (
    <>
      <BeHead />
      <div className="content-body">
        <div className="container-fluid">
          <div className="">
            {/* <div className="col-lg-4 col-md-5 px-5 pt-5">
              <div className="mb-4">
                <img className="ml-5 logo-bloc" src={'/Assets/Images/Bloc-Logo.png'} alt="logo-bloc" />
              </div>
              <div className="py-5">
                <img className='illustration-1 rounded w-75' src={"/Assets/Images/image1.png"} alt="illustration" />
              </div>
              <div className='list-col'>
                <ul className="list-row fw-bold d-flex my-5 justify-content-center">
                  <li className="px-3 border-end border-dark-50">Help</li>
                  <li className="px-3 border-end border-dark-50">Terms & Condition</li>
                  <li className="px-3">Privacy Policy</li>
                </ul>
              </div>
            </div> */}
            {/* <div className="col-lg-8 col-md-7 bg-white p-5 ml-4"> */}
            <div className="bg-white p-5 ml-4">
              <div className="mb-5">
                <p className="fw-bold fs-3">
                  {/* <LiaTimesSolid /> */}
                  </p>
                <div className="title pt-2">
                  <h1 className="">Selectionnez une Etape</h1>
                  <p className="fst-italic">NB: Vous pourrez modifier le titre du projet plustard si vous le souhaitez</p>
                </div>
              </div>
              <TableContainer component={Paper}>
                <Table sx={{ minWidth: 650 }} aria-label="simple table">
                  <TableHead>
                    <TableRow>
                      <TableCell>ETAPE</TableCell>
                      <TableCell align="right">TITRE</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {rows.map((row) => (
                      <TableRow
                        key={row.step}
                        component={Link}
                        to={`/bureau-etude/${encodeURIComponent(row.title)}`}
                        sx={{ 
                          '&:last-child td, &:last-child th': { border: 0 },
                          textDecoration: 'none',
                          color: 'inherit',
                          cursor: 'pointer',
                          '&:hover': {
                            backgroundColor: '#f5f5f5',
                          }
                        }}
                      >
                        <TableCell component="th" scope="row">
                          {row.step}
                        </TableCell>
                        <TableCell align="right">{row.title}</TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}